import { useQuery } from '@apollo/client';
import { ConditionalWrapper } from '@eti/components';
import { useProperty } from '@eti/providers';
import { Collection, DevBar } from '@eti/debug';
import Loading from '../../../common/loading/components/Loading';
import ErrorPage from '../../status-pages/components/ErrorPage';
import ChangeTripPage from '../components/ChangeTripPage';
import { ChatProvider } from '../../../common/chat/ChatContext';
import { isDev } from '../../../common/debug/utils';
import { DebugCommonComponents, DebugGraphQlResponses } from '../../../common/debug/components';
import { ORDER_QUERY } from './queries';

const ChangeTripPageGraphqlContainer = () => {
  const { p } = useProperty();
  const isChatEnabled =
    p('Chat.Widget.Rebooking.Enabled') &&
    (p('Chat.WebMessages.Enabled') || p('Chat.Widget.Enabled') || p('Chatbot.Oriana.Enabled'));

  const { data, loading, error } = useQuery(ORDER_QUERY, {
    fetchPolicy: 'no-cache',
  });

  if (loading) {
    return <Loading />;
  }

  if (error || !data?.orderNew) {
    return <ErrorPage />;
  }

  const userName = data.orderNew.customerDetails.name;
  const tripData = data.orderNew.trips[0];

  return (
    <>
      <ConditionalWrapper
        condition={isChatEnabled}
        wrapper={(children) => (
          <ChatProvider supportedChatTypes={['genesys']} userName={userName}>
            {children}
          </ChatProvider>
        )}
      >
        <ChangeTripPage trip={tripData} />
      </ConditionalWrapper>
      {isDev && (
        <DevBar>
          <Collection>
            <DebugGraphQlResponses />
            <DebugCommonComponents />
          </Collection>
        </DevBar>
      )}
    </>
  );
};

export default ChangeTripPageGraphqlContainer;
